export const currencyType = (symbol) => {
  if (!symbol) return "";
  const value = symbol.toLowerCase();
  let data = null;
  switch (value) {
    case "eur":
      data = "EUR";
      break;
    case "usd":
      data = "USD";
      break;
    case "gbp":
      data = "GBP";
      break;
    case "tl":
      data = "TL";
      break;
    default:
      data = "";
      break;
  }
  return data;
};
